export default __webpack_public_path__ + "static/media/mars21.c2865115.gif";